import { render, staticRenderFns } from "./RegionCardTable.vue?vue&type=template&id=1c077f12"
import script from "./RegionCardTable.vue?vue&type=script&lang=js"
export * from "./RegionCardTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports